import ModelUtil from '@leverege/model-util';
import ItemTypeModel from "./ItemTypeModel.js";
const TYPE = 'detail.Item';
function getType(model, type) {
  return model?.types?.[type];
}

// separate the details and the layout for them so
// i can reuse the detail part

function create() {
  return {
    type: TYPE,
    display: 'block',
    types: {},
    editable: true
  };
}
const mod = {
  TYPE,
  create,
  getType,
  addType,
  ...ModelUtil.createAllValue('display'),
  ...ModelUtil.createAllMap('types', 'type', 'types'),
  ...ModelUtil.createAllValue('editable')
};
function addType(model, type, extra) {
  return mod.types().set(model, type, ItemTypeModel.create(type, extra));
}
export default mod;